import { Cheque, Item } from '@baemingo/table-events/dist/types';
import { v4 as uuid } from 'uuid';

type Props = {
  serviceChargeItems: Item[];
  cheque?: Cheque;
  api: any;
};

export const filterOutServiceCharge = (chequeItems: Item[]) => {
  return chequeItems.filter((item) => !item.title.toLowerCase().includes('service charge'));
};

export const extractServiceCharge = (chequeItems: Item[]) => {
  const serviceChargeItems = chequeItems.filter((item) =>
    item.title.toLowerCase().includes('service charge'),
  );
  const serviceChargeItem = serviceChargeItems[0];

  return { serviceChargeItem, serviceChargeItems };
};

export const isServiceChargeItem = (title: string) => {
  const formattedTitle = title.toLowerCase().replace(/\s/g, '');

  return formattedTitle.includes('servicecharge');
};

export const extractServiceChargePercentage = (title: string) => {
  const findPercentageValue = /\d+(?:[.,]\d+)?\s*%/;
  const serviceChargePercentage = title.match(findPercentageValue);

  if (!serviceChargePercentage || !serviceChargePercentage[0]) return 100;

  return parseFloat(serviceChargePercentage[0].replace(',', '.'));
};
